export default "__VITE_ASSET__CZhOECNO__"